import PropTypes from 'prop-types';
import {useEffect,useState} from 'react';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from "@mui/material/Typography";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DownloadIcon from '@mui/icons-material/Download';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Tooltip from '@mui/material/Tooltip';

import config from '../../config/config';
import {useCreateSessionFileMutation} from '../../redux/services/sessionFileApi';

const handleGenerateFile = ({
  sessionId, 
  fileType, 
  createSessionFile,
  afterDownload,
}) => async e => {
  const req = await createSessionFile({session_id: sessionId, file_type: fileType});
  const url = req?.data?.data?.[0]?.url;
  if (req.error || !url) return;
  if (afterDownload) afterDownload();
  window.open(url, '_blank');
};

const DownloadArtifactButton = props => {
  const {session, docType} = props;
  const [createSessionFile, response] = useCreateSessionFileMutation();
  const onGenerateFile = handleGenerateFile({
    createSessionFile,
    sessionId: session.id,
    fileType: docType,
    afterDownload: props.afterDownload,
  });
  const isInvoice = docType === 'invoice';
  const Icon = isInvoice ? AttachMoneyIcon : AttachFileIcon;
  const url = response?.data?.data?.[0].url;
  const actionText = url ? 'View' : 'Create';
  const buttonText = isInvoice ? `${actionText} Invoice` : `${actionText} Note PDF`;
  const isDisabled = !(session.is_completed || (session.is_canceled && session.cancellation_fee > 0)) || response?.isLoading;
  const shouldGeneratePDF = !url || props.pdfMustRefresh;
  const shouldUseHref = url && !props.pdfMustRefresh;
  const childProps = {
    ...props,
    href: shouldUseHref ? url : null,
    target: shouldUseHref ? '_blank' : null,
    disabled: isDisabled,
    // variant: props?.iconOnly ? null : (props.variant || 'contained'),
    variant: shouldUseHref ? 'contained' : 'outlined',
    // color: url ? 'success' : 'primary',
    startIcon: props?.iconOnly || props?.textOnly ? null : <Icon/>,
    fullWidth: props.fullWidth || null,
    size: props.size,
    color: url ? 'success' : 'primary',
    onClick: shouldGeneratePDF ? onGenerateFile : null,
  };
  if (props.iconOnly) {
    return (
      <Tooltip title={buttonText}>
        <IconButton {...childProps}>
          {shouldUseHref ? <DownloadIcon/> : <Icon/>}
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Button {...childProps}>
      {buttonText}
    </Button>
  );
};

DownloadArtifactButton.defaultProps = {
  iconOnly: false,
  textOnly: false,
  size: 'medium',
};

DownloadArtifactButton.propTypes = {
  session: PropTypes.number,
  docType: PropTypes.string, // 'note', 'invoice'
};

export default DownloadArtifactButton;